export default "__VITE_ASSET__e101e76b__"